import { render, staticRenderFns } from "./AdvertisementContentPanel.vue?vue&type=template&id=d807970c&scoped=true"
import script from "./AdvertisementContentPanel.vue?vue&type=script&lang=js"
export * from "./AdvertisementContentPanel.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementContentPanel.vue?vue&type=style&index=0&id=d807970c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d807970c",
  null
  
)

export default component.exports